import { serializeFrequencyLabel } from './serializeFrequencyLabel';
import { serializeLabel } from './serializeLabel';

export interface IGetToggleLabel {
  categoryName: string;
  frequency?: string;
}

export function getToggleLabel({ categoryName, frequency }: IGetToggleLabel) {
  const categoryLabel = serializeLabel({ categoryName });
  const frequencyLabel = serializeFrequencyLabel(frequency);

  return frequencyLabel ? `${categoryLabel}/${frequencyLabel}` : categoryLabel;
}
